import jump from 'jump.js';

export default {
  init() {

    $('.business-family__logo').on('click', function() {

      if($(this).hasClass('disabled')) {
        return;
      }
      let $businessModal = $(this).next('.business-family__modal');
      let $modalContainer = $(this).parents('.row').next().find('.business-family__modal-container');

      $('.business-family__modal-container').removeClass('active');

      $('.business-family__col--active').removeClass('business-family__col--active');
      $(this).addClass('business-family__col--active');
      $businessModal.slideToggle();


      $('.business-family__modal-container').empty();
      $(this).next('.business-family__modal').children().clone().wrapAll('<div class="business-content"></div>').appendTo($modalContainer);
      $('.business-content').hide();

      $modalContainer.addClass('active');

      $('.business-content').fadeIn();

      var image = $modalContainer.find('.business-family__modal-image img');

      $(image[0]).trigger('load_lazy_image');

      if($modalContainer.is(':visible')) {
        jump($modalContainer[0], {
          offset: -279,
          duration: 400,
        });
      }
      else {
        jump($businessModal[0], {
          duration: 400,
        });
      }
    });

    $(document).on('click', '.business-family__close-btn', function(e) {
      e.preventDefault();

      $('.business-family__col--active').removeClass('business-family__col--active');
      $('.business-family__modal-container').removeClass('active');
      $('.business-family__modal').slideUp();
    });

    $(window).on('resize', function() {
      if( $('.business-family__col').hasClass($('.business-family__col--active')) ) {
        $('.business-family__close-btn').trigger('click');
      }
    });


    $( window ).on( 'hashchange', function() {
      if($(location.hash).length) {
        $(location.hash).trigger('click');
      }
    }).trigger('hashchange');

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/business-family.js